import { useQuery } from '@tanstack/react-query';

import getOperator from 'Api/operator/getOperator';

import getAllOperatorsResponse from './model/response/getAllOperatorsResponse';

const useGetAllOperator = () =>
  useQuery({
    queryKey: ['all-operators'],
    queryFn: async () => {
      const response = await getOperator();

      const result = getAllOperatorsResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 15 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });

export default useGetAllOperator;
